module.exports = __webpack_public_path__ + "img/svg/home.62ba43b5842dca246fdd4c7a7a76d978.svg";